/**
 * 비로그인 '최근 본 단지' — 이 기기(localStorage) 기준 (v2 상태 변형 S4, 2026-09-22 v2h).
 * 로그인 사용자는 서버 recent API 를 쓰고, 이 목록은 비로그인 마이 화면에서만 보여 준다.
 * 개인정보 없음 — 단지 공개 정보(id·이름·주소·가격·썸네일)만 저장. 최대 20개, 최신순.
 */

export const LOCAL_RECENT_KEY = 'voonang_recent_views';
const MAX_ITEMS = 20;

export interface LocalRecentView {
  id: number;
  house_manage_no?: string | null;
  title: string;
  address?: string | null;
  min_price?: number | null;
  max_price?: number | null;
  image?: string | null;
  viewed_at: number;
}

export function getLocalRecentViews(): LocalRecentView[] {
  try {
    const raw = localStorage.getItem(LOCAL_RECENT_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((v) => v && typeof v.id === 'number' && v.title) : [];
  } catch {
    return [];
  }
}

export function addLocalRecentView(item: Omit<LocalRecentView, 'viewed_at'>): void {
  try {
    const rest = getLocalRecentViews().filter((v) => v.id !== item.id);
    const next = [{ ...item, viewed_at: Date.now() }, ...rest].slice(0, MAX_ITEMS);
    localStorage.setItem(LOCAL_RECENT_KEY, JSON.stringify(next));
  } catch {
    // 저장 불가(사파리 개인정보 보호 모드 등) — 무시
  }
}
